var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6625 10.0878C19.8903 10.3157 19.8903 10.685 19.6625 10.9128L12.6625 17.9128C12.4347 18.1406 12.0653 18.1406 11.8375 17.9128L8.33752 14.4128C8.10971 14.185 8.10971 13.8157 8.33752 13.5878C8.56533 13.36 8.93467 13.36 9.16248 13.5878L12.25 16.6754L18.8375 10.0878C19.0653 9.86004 19.4347 9.86004 19.6625 10.0878Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/Pass.e673aa3aaf6f54526bc9f35e7b75539f.svg";
export { ForwardRef as ReactComponent };